import pincodeService from "./PincodeService";

export function getPincodeConfig(countryCode) {
    if (!countryCode) return null;
    const records = pincodeService.records;
    return records[countryCode.toUpperCase()] || null;
}

export function validatePincodeByCountry(countryCode, pincode) {
    const config = getPincodeConfig(countryCode);
    if (!config || !config.regexForPostalCode) {
        return true;
    }
    const pattern = config.regexForPostalCode.replace(/\\\\/g, '\\');
    const regex = new RegExp(`^${pattern}$`);
    return regex.test(pincode);
}

export function getDefaultValue(countryCode) {
    const config = getPincodeConfig(countryCode);
    if (config && config.defaultValue) {
        return config.defaultValue;
    }

    return null
}

// Computes the hidePinCode display flag for an address on load and self-heals a missing pinCode
// when the country has a fixed default (e.g. HK -> 999077). The field is hidden in that case, so
// the user cannot type the value manually - records saved while the auto-populate bug was live
// hold pinCode "" and would otherwise be stuck failing backend validation. Autosave picks up the
// healed value as a pending change and persists it.
export function withComputedHidePinCode(address) {
    const next = { ...(address ?? {}) };
    const defaultPin = next.country ? getDefaultValue(next.country) : null;
    next.hidePinCode = Boolean(defaultPin);
    if (defaultPin && !next.pinCode) {
        next.pinCode = defaultPin;
    }
    return next;
}
